import React, { useContext, useState } from "react";

import styles from "./styles";
import { FiX } from "react-icons/fi";
import { IconButton } from "@mui/material";
import { api, Booking } from "../../../../logic/api";
import { SessionContext } from "../../../../utility/useSession";
import { ReleaseFlag, useReleaseManagement } from "../../../../utility/feature-management";
import ConfirmationDialog from "../../../../components/notifications/confirmationDialog/ConfirmationDialog";
import { t } from "i18next";

const StatusBadges: React.FunctionComponent<{
    labels: string[];
    booking: Booking;
    refreshBooking: () => void
}> = (props) => {
    const session = useContext(SessionContext);
    const removeLabelAPI = api.hooks.booking.removeLabel();
    const isRemoveLabelEnabled = useReleaseManagement(ReleaseFlag.releaseRemoveEarlyReturn);

    const [selectedLabel, setSelectedLabel] = useState('');
    const [showRemoveLabelDialog, setShowRemoveLabelDialog] = useState(false);

    const removableLabels = [
        'early-return'
    ]

    const showRemoveLabelDialogPopup = (label: string) => {
        setSelectedLabel(label);
        setShowRemoveLabelDialog(true);
    }

    const removeLabel = async (label: string) => {
        return new Promise<boolean>((accept) => {
            removeLabelAPI.send(session.current.context, { bookingId: props.booking.id, label }, (updatedBooking) => {
                if (updatedBooking == null) {
                    accept(false);
                    return;
                }

                accept(true);
                props.refreshBooking();
                return;
            });
        });
    };

    return (
        <>
            {isRemoveLabelEnabled && (
                <ConfirmationDialog
                    title={t("confirmationDialog.removeLabel.title")}
                    message={t("confirmationDialog.removeLabel.message")}
                    buttonCancellationText={t("confirmationDialog.removeLabel.cancel")}
                    buttonConfirmationText={t("confirmationDialog.removeLabel.confirm")}
                    show={showRemoveLabelDialog}
                    onClose={(shouldRemove) => {
                        if (shouldRemove) {
                            removeLabel(selectedLabel)
                        }

                        setShowRemoveLabelDialog(false)
                    }}
                />
            )}<div style={{ width: 'auto', textAlign: 'left', marginTop: -4 }}>
                {props.labels.map((label, index) => {
                    return (
                        <div key={`${label}-${index}`} data-testid={`status-badge-${label}`} style={styles.statusLozenge}>{formatLabel(label)}{isRemoveLabelEnabled && removableLabels.includes(label) && <IconButton
                            color="inherit"
                            style={{ padding: "0px 0px 0px 5px", height: "fit-content", width: "fit-content" }}
                            onClick={() => showRemoveLabelDialogPopup(label)}>
                            <FiX fontSize="medium" /></IconButton>}
                        </div>
                    );
                })}
            </div></>
    );
}

//split, capitalize, rejoin with spaces
const formatLabel = (label: string) => label.split('-').map(lw => lw.charAt(0).toUpperCase() + lw.slice(1)).join(' ');

export default StatusBadges;